exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".app-voucher-page .form-content .el-form-item{margin-bottom:8px}.app-voucher-page .form-content .el-form-item__label{padding-right:34px;font-size:16px}.app-voucher-page .form-content .el-form-item__content{font-size:16px;color:#666}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-7405779c","scoped":false,"hasInlineConfig":false}!./node_modules/postcss-loader/lib!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/control/app/voucher.vue
// module id = 896
// module chunks = 0